module.exports = __webpack_public_path__ + "img/img3.0da76458.png";